import { DeferredQueryInput, QueryV1Input } from '../../../types/J1QL';
import { QueryV1InStandard } from '../../graphql/queries/J1';
import useJ1QLWithCursorPagination from './useJ1QLWithCursorPagination';
import mergeJ1QLDataResponses from '../utils/mergeJ1QLDataResponses';

const useQueryV1InStandard = ({
  queryV1Input,
  standardId = '',
  skip = false,
}: {
  queryV1Input: QueryV1Input;
  standardId?: string;
  skip?: boolean;
}) => {
  const queryV1InputToHook: DeferredQueryInput = { ...queryV1Input };

  if (standardId) {
    if (!queryV1InputToHook.variables) {
      queryV1InputToHook.variables = {};
    }

    queryV1InputToHook.variables.standardId = standardId;
  }

  const j1QLResult = useJ1QLWithCursorPagination({
    query: QueryV1InStandard,
    dataPath: 'queryV1InStandard',
    cursorPath: 'queryV1InStandard.cursor',
    mergeDataResponses: mergeJ1QLDataResponses,
    variables: {
      ...queryV1InputToHook.variables,
      query: queryV1InputToHook.query,
      flags: queryV1InputToHook?.flags,
      includeDeleted: queryV1InputToHook?.includeDeleted,
      cursor: queryV1InputToHook?.cursor,
    },
    skip,
    // I cannot stress enough how important this combination of fetch policies is.
    // Apollo Client v3 changed some of the fetch policy behavior, so on a fetchMore
    // a refetch is triggered with the original variables.  The nextFetchPolicy here
    // makes sure we don't make a network call on that erroneous refetch- henry
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'cache-first',
  });

  return {
    ...j1QLResult,
  };
};

export default useQueryV1InStandard;
